import React, { Component } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

class FullWidthImage extends Component {

  componentDidMount(){
    AOS.init({
      duration : 1200,
      disable: 'mobile'
    })
  }

  render() {

    const divStyle = {
      backgroundImage: 'url(' + this.props.image + ')',
      backgroundSize: "cover",
      backgroundPosition: "center",
    };

    return (
      <div data-aos='fade-up' className={`d-flex align-items-center fullWidthImage mt-5 mb-5`} style={divStyle} >
        <div className="content-wrapper container-fluid">
          <div className="row d-flex align-items-center mt-5">
            <div className={`col-12 standard-padding`}>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default FullWidthImage;
